import React, { useRef } from 'react';
import { Card, Typography, Button, Row, Col, Divider, message } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { formatRupiah } from 'src/module/helpers';
import PaymentSteps from './PaymentStep';
import ExpiredDay from './expiredDay';

const { Text, Title } = Typography;

const PaymentCheckout = ({ detailInvoice }) => {
    const bank = detailInvoice?.bank?.availBank;
    const qrRef = useRef(null);

    console.log(bank)

    if (bank?.status === "EXPIRED") {
        return (
            <div style={{ textAlign: 'center', padding: '20px' }}>
                <Text type="danger" style={{ display: 'block', fontSize: 16 }}>
                    Pembayaran telah usang atau expired, Anda akan diarahkan ke link pembayaran baru.
                </Text>
            </div>
        );
    }

    // ======== QRIS VIEW ========
    if (bank?.channelCode === "QRIS") {
        const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=${encodeURIComponent(
            bank?.channelProperties?.qrString || ''
        )}`;

        // Fungsi untuk menyimpan QR image
        const handleDownloadQR = async () => {
            try {
                const response = await fetch(qrUrl, { mode: 'cors' });
                const blob = await response.blob();
                const blobUrl = window.URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = blobUrl;
                link.download = `QRIS-${bank?.transferAmount}.png`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                window.URL.revokeObjectURL(blobUrl); // bersihkan URL blob
                message.success('QR Code berhasil disimpan!');
            } catch (err) {
                console.error(err);
                message.error('Gagal menyimpan QR Code!');
            }
        };


        return (
            <div>
                <Card>
                    <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
                        <Col>
                            <Text strong>Total Pembayaran</Text>
                        </Col>
                        <Col>
                            <Title level={4} style={{ margin: 0 }}>
                                {formatRupiah(bank?.transferAmount, true)}
                            </Title>
                        </Col>
                    </Row>

                    {detailInvoice?.bank?.expiryDate && (
                        <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
                            <Col>
                                <Text strong>Bayar Dalam</Text>
                            </Col>
                            <Col style={{ textAlign: 'right' }}>
                                <ExpiredDay expiredDate={detailInvoice?.bank?.expiryDate} />
                            </Col>
                        </Row>

                    )}


                    <Divider />

                    <div style={{ textAlign: 'center', marginBottom: 16 }}>
                        <img
                            src={bank?.logo}
                            alt="QRIS Logo"
                            style={{ height: 60, marginBottom: 8 }}
                        />
                        <Title level={4}>Pembayaran via QRIS</Title>
                        <Text type="secondary">
                            Scan kode QR berikut menggunakan aplikasi e-wallet atau mobile banking Anda
                        </Text>
                    </div>

                    {/* Centered QR Code */}
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            margin: '24px 0',
                        }}
                    >
                        <div
                            ref={qrRef}
                            style={{
                                background: '#fff',
                                padding: 12,
                                borderRadius: 12,
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                display: 'inline-block',
                            }}
                        >
                            <img
                                src={qrUrl}
                                alt="QRIS Code"
                                style={{
                                    width: 220,
                                    height: 220,
                                    display: 'block',
                                }}
                            />
                        </div>
                    </div>

                    {/* Tombol Simpan QR */}
                    <div style={{ textAlign: 'center', marginBottom: 24 }}>
                        <Button
                            icon={<DownloadOutlined />}
                            onClick={handleDownloadQR}
                            type="primary"
                            size="middle"
                        >
                            Simpan QR
                        </Button>
                    </div>

                    <Divider />

                    <Text type="secondary" style={{ display: 'block', textAlign: 'center', marginBottom: 8 }}>
                        Setelah pembayaran berhasil, sistem akan otomatis memverifikasi dalam waktu kurang dari 10 menit.
                    </Text>

                    <PaymentSteps
                        paymentData={detailInvoice?.bank?.instructions}
                        bankAccount={detailInvoice?.bank}
                    />
                </Card>

                <div
                    style={{
                        position: 'fixed',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        padding: 16,
                        background: '#fff',
                        borderTop: '1px solid #f0f0f0',
                        textAlign: 'center',
                    }}
                >
                    <Button type="primary" size="large">
                        OK
                    </Button>
                </div>
            </div>
        );
    }

    // ======== tampilkan metode transfer lain (BRI, BCA, dll) di sini ========
    return <div>... (tampilan default kamu tetap di sini)</div>;
};

export default PaymentCheckout;
